import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import i18nStore from '../public/locales/index';

const DEFAULT_LAN = 'en';

// 获取初始语言
// 注意：在客户端立即读取 URL 参数，在服务端返回默认语言
const getInitialLanguage = () => {
  // 服务端渲染时，返回默认语言
  if (typeof window === 'undefined') {
    return DEFAULT_LAN;
  }

  // 客户端：从 URL 读取语言参数
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const lanParam = urlParams.get('lan');

    // 验证语言是否存在
    if (lanParam && i18nStore[lanParam]) {
      return lanParam;
    }
  } catch (e) {
    // 忽略错误，使用默认语言
  }

  return DEFAULT_LAN;
};

// 初始化 i18n
i18n.use(initReactI18next).init({
  resources: i18nStore,
  lng: getInitialLanguage(),
  fallbackLng: DEFAULT_LAN,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false, // 禁用 Suspense，避免 SSR 问题
  },
});

export default i18n;
